/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Signup_SuccessInputs */

const en_newsletter_signup_success = /** @type {(inputs: Newsletter_Signup_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're on the list. Watch your inbox.`)
};

/**
* | output |
* | --- |
* | "You're on the list. Watch your inbox." |
*
* @param {Newsletter_Signup_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_signup_success = /** @type {((inputs?: Newsletter_Signup_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Signup_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_signup_success(inputs)
});